/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    empty: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    empty: false,
};

const Block = (props) => {
    const classNames = [
        'c-block',
        props.empty ? 'c-block_empty' : 'c-block_shadow',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Block.propTypes = propTypes;

Block.defaultProps = defaultProps;

export default Block;
